 <!-- Wrapper Body -->
 <div class="wrapper-body" *ngIf="show">
    <div class="page-header d-flex align-items-center">
      <h3>Canceled Appointments</h3>
      <a href="javascript:void" class="theme-button grey ml-auto mr-3" onclick="filterButton()">Filter</a>
      <button type="button" class="theme-button grey mr-md-3 my-3 my-md-0" onclick="exportCSV()">Export to CSV</button>
    </div>
    <div class="content">
      <form class="custom-form d-none" id="filterShow">
        <div class="row">
          <div class="col-md-6">
            <input type="text" id="filterSearch" placeholder="Type here to search" onkeyup="appointmentFilterFunction()">
          </div>
        </div>
      </form>
      <div class="card" *ngIf="cancelledAppointments.length>0">
        <div class="table-responsive">
          <table class="custom-table filterTable" id="appointmentTable">
            <thead>
              <tr class="header">
                <th class="tablewidth">Client Name</th>
                <th>Cell Number</th>
                <th>Email</th>
                <th>Assessment</th>
                <th>Diagnostician</th>
                <th>Appt. Date</th>
                <th class="text-center">Reason</th>
              </tr>
            </thead>
            <tbody >
  
              <!-- Loop -->
              <tr *ngFor="let appointment of cancelledAppointments">



                <td class="tablewidth">{{appointment.parentDetails.studentFirstName}} {{appointment.parentDetails.studentLastName}}</td>
                <td>{{appointment.parentDetails.cellNumber}}</td>
              <td>{{appointment.parentDetails.emailAddress}}</td>
              <td class="text-center">{{appointment.appointmentDetails.assesmentType}}</td>
              <td class="text-center">{{appointment.appointmentDetails.diagnosticianName}}</td>
              <td>{{appointment.appointmentDetails.schedules[0].appointmentDate}}</td>
              <td class="text-center" [ngClass]="{
                'alert-danger' : appointment.appointmentDetails.schedules[0].assesmentComments=='Cancel',
                'alert-warning' : appointment.appointmentDetails.schedules[0].assesmentComments=='Reschedule'}">
              {{appointment.appointmentDetails.schedules[0].assesmentComments}}
              </td>
              <!-- <td class="text-danger" style="max-width: 160px; white-space: pre-wrap;">{{appointment.appointmentDetails.schedules[0].assesmentComments}}</td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div *ngIf="cancelledAppointments.length<1">
        <div class="row">
          <div class="col-12">
            <div class="card py-5 px-2 text-center">
              <h4 class="text-grey">No Canceled Appointments</h4>
              <!-- <p class="text-grey mb-0">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div >
    <ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple">
        <!-- <p style="color: white">Please Wait... </p> -->
      </ngx-spinner>
  </div>